// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.WaterfallChartOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import ChartHasThresholdOptionBuilder from './Izenda.ChartHasThresholdOptionBuilder';
import highchartUtils from 'share/components/charting/highcharts/Izenda.HighchartUtils';
import { get, forEach, merge, isFunction, last, nth, getOr, isNil } from 'lodash/fp';
import { exportClass } from 'share/Izenda.ServiceProvider';

@exportClass('WaterfallChartOptionsBuilder')
export default class WaterfallChartOptionsBuilder extends ChartHasThresholdOptionBuilder {
  constructor(...baseArgs) {
    super(...baseArgs);
  }

  /**
   * Build Highchart variable options for each chart type
   * @param {string} visualType Highchart chart type
   * @param {Object} highchartOptions Highchart options
   * @param {Object} chartData Chart data
   * @returns {Object}
   */
  buildOptionsByType(visualType: string, userOptions: any, dataParser: any): any {
    const chartOptions = super.buildOptionsByType(visualType, userOptions, dataParser, false) || {};

    const colors = isNil(userOptions.colors) ? this.DefaultColors : userOptions.colors;
    const xAxis = chartOptions.xAxis;

    const sumTitle = escape(userOptions.izTotalLabel);

    function addSumItem(xAxis, serie) {
      const lastItem = last(serie.data);
      const biasItem = nth(-2, serie.data);
      const xAxisType = getOr('', 'type', xAxis);

      const sumItem = {
        isSum: true,
        sumTitle: sumTitle
      };

      const lastX = get('x', lastItem);
      const biasX = get('x', biasItem);
      let sumX;

      if (lastX && biasX) {
        switch (xAxisType) {
          case 'linear':
            sumX = lastX + (lastX - biasX);
            break;
          case 'datetime':
            sumX = new Date(Date.parse(lastX) + (Date.parse(lastX) - Date.parse(biasX)));
            break;
          default:
          // do nothing
        }

        sumX && (sumItem.x = sumX);
      }

      serie.data.push(sumItem);
    }

    let waterfallSeries = chartOptions.series;

    // add total label column for waterfall chart (sum all value )
    forEach(serie => {
      addSumItem(xAxis, serie, userOptions);
    }, waterfallSeries);

    let thresholdSeries = chartOptions.thresholdSeries;

    highchartUtils.setColorPointForAreaLine(userOptions, waterfallSeries, colors);

    const series = [...waterfallSeries, ...thresholdSeries];

    return {
      series: series,
      xAxis: merge(chartOptions.xAxis, {
        labels: {
          formatter: function() {
            if (this.isLast) {
              return sumTitle;
            }
            var formatter = get('labels.formatter', xAxis);
            return isFunction(formatter) ? formatter.call(this) : '';
          }
        }
      }),
      yAxis: chartOptions.yAxis,
      tooltip: {
        shared: true
      }
    };
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartChart/Izenda.WaterfallChartOptionsBuilder.js